<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 11.0711L7.53553 7.53554L4 4.00001" stroke="currentColor" stroke-linecap="round"/>
<path d="M8 11.0711L11.5355 7.53554L8 4.00001" stroke="currentColor" stroke-linecap="round"/>
</svg>
